import getDomainName from '@/iframe/utils/getDomainName';
import createIframeApi from './createIframeApi';

export default function createIframe({
  mountTargetSelector,
  apiUrl,
  iframeUrl,
}) {
  const uuid = Math.random();

  const iframe = document.createElement('iframe');

  function getIframeSrc() {
    if (iframeUrl) {
      return iframeUrl;
    }

    return process.env.NODE_ENV === 'production'
      ? `https://script.${getDomainName(apiUrl)}/${process.env.VUE_APP_IFRAME_HOST_PATH}`
      : '/iframe.html';
  }

  iframe.src = `${getIframeSrc()}?uuid=${uuid}`;

  iframe.style.width = '100%';
  iframe.style.border = '0';
  iframe.style.backgroundColor = 'transparent';
  iframe.allowTransparency = 'true';

  const mountTarget = mountTargetSelector instanceof HTMLElement
    ? mountTargetSelector
    : document.querySelector(mountTargetSelector);

  mountTarget.innerHTML = '';
  mountTarget.append(iframe);

  const iframeApi = createIframeApi(iframe, uuid);

  iframeApi.onSyncSize(({ height }) => {
    const newHeight = `${height}px`;

    if (iframe.style.height !== newHeight) {
      iframe.style.height = newHeight;
    }
  });

  return iframeApi;
}
